export const TeamChatSoftLinkifyHintTestIds = {
  ROOT: 'team-chat.soft-linkify-hint',
};
